import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SwitchComponent } from './switch.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: SwitchComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class SwitchRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/switch/switch-routing.module.ts